import { Component, NgZone, OnInit } from '@angular/core';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { ValidatorPasswordService } from "../components/password-validator/validator-password.service";
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'

@Component({
  selector: 'app-reset-password-by-email',
  templateUrl: './reset-password-by-email.component.html',
  styleUrls: ['./reset-password-by-email.component.sass']
})
export class ResetPasswordByEmailComponent implements OnInit {
  public defaultSubscriber: string;
  public password1;
  public password2;
  public passwordConfirm;
  public requiredAccountUpdate;
  public actualPassword;
  public code: string;

  constructor(private services: Service,
              private global: GlobalService,
              private loadingScreenService: LoadingScreenService,
              private validatorPasswordService: ValidatorPasswordService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private location: Location,
              private zone: NgZone) {
  }

  ngOnInit() {
    this.getRouteInfo();
    if (this.global.sessionReview() == true) {
      this.defaultSubscriber = JSON.parse(atob(sessionStorage.getItem("defaultSubscriber")));
      this.requiredAccountUpdate = JSON.parse(atob(sessionStorage.getItem("requiredAccountUpdate")));
      this.password1 = '';
      this.password2 = '';
    }
  }

  getRouteInfo() {
    localStorage.setItem('code-password', this.router.parseUrl(this.router.url).queryParams['token']);
    this.location.go('recover-password');
    this.code = localStorage.getItem('code-password');
    localStorage.removeItem('code-password');
    this.loadingScreenService.startLoading();
    if (this.code.toString().length > 0 && this.code.toString() !== 'undefined') {
      this.callRecoverPasswordValidate(this.code);
    } else {
      this.router.navigate(['home']).then();
    }
  }

  validateQuestion() {
    if (this.password1 === '' || this.password1 === undefined) {
      this.global.notif("Escriba su nueva contraseña");
      return false;
    }
    if (this.password2 === '' || this.password2 === undefined) {
      this.global.notif("Debe confirmar la contraseña");
      return false;
    }
    if (this.password1 !== this.password2) {
      this.global.notif("La contraseña actual no coincide con la confirmación.");
      return false;
    } else {
      this.passwordConfirm = this.password1;
    }
    return true;
  }

  continuePassword() {
    this.global.validateSession();
    if (this.validateQuestion()) {
      this.passwordConfirm = this.password1;
      const payload = {
        code: this.code,
        password: this.passwordConfirm
      };
      this.password1 = '';
      this.password2 = '';
      this.loadingScreenService.startLoading();
      this.callRecoverPasswordFinish(payload);
    } else {
      return;
    }
  }

  onKey(event: any) {
    this.validatorPasswordService.onKey(event.target.value);
  }

  callRecoverPasswordValidate(code) {
    this.services.recoverPasswordValidate(code).subscribe(
      (resp: any) => {
        this.loadingScreenService.stopLoading();
        if (resp.hasError) {
          this.global.notif(resp.errorDisplay);
          setTimeout(() => {
            this.router.navigate(['login']).then(
              () => {
                this.reloadPage();
              }
            );
          }, 5000);
        }
      },
      error => {
        this.loadingScreenService.stopLoading();
        this.global.notif(error.ErrorDesc);
        this.router.navigate(['login']).then();
      }
    );
  }

  callRecoverPasswordFinish(dto) {
    this.services.recoverPasswordFinish(dto.code, dto.password).subscribe(
      (resp: any) => {
        this.loadingScreenService.stopLoading();
        if (!resp.hasError) {
          this.global.notif('Su clave a sido cambiada de forma exitosa');
          setTimeout(() => {
            this.router.navigate(['login']).then(
              () => {
                this.reloadPage();
              }
            );
          }, 5000);
        } else {
          this.global.notif(resp.errorDisplay);
        }
      },
      error => {
        this.loadingScreenService.stopLoading();
        this.global.notif(error.ErrorDesc);
      }
    );
  }

  reloadPage() {
    this.zone.runOutsideAngular(() => {
      location.reload();
    });
  }
}
